import { render } from "./index.vue?vue&type=template&id=c4e15960&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=c4e15960&lang=scss&scoped=true"
import "./index.vue?vue&type=style&index=1&id=c4e15960&lang=scss"

import exportComponent from "/data/jenkins/workspace/talk-community-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4e15960"]])

export default __exports__